<div class="row seedfullPage">
  <div class="seedEfulfillmentOuter" id="orderView">

    <div class="seedEfulfillment">
      <div class="order-view-sec breadcrumbOuter padding-0" >
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" (click)="navigateToAssociateLanding()">Associate Order</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item" *ngIf="!readOnlyAccess">
              <span>Create Order</span>
            </li>
            <li class="breadcrumb-item breadcrumbColor" aria-current="page" *ngIf="readOnlyAccess">
              <span>{{associateOrder.AssociateOrderId}}</span>
            </li>
          </ol>
        </nav>
      </div>
      <!--Crop year and filter section-->
      <div class="OrderReleaseTop">
        <div *ngIf="error">
          <div class="row">
            <div class="col-md-12">
              <div class="inline-error" *ngIf="error">
                <div class="row">
                  <div class="col-md-12 padding-l0">
                    <ol class="error-list">
                      <li class="justify-content-center align-self-center" *ngFor="let err of errorsList">
                        {{err}}
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--Ship to - Confirmation Email Section-->
        <div class="row">
          <div class="col-md-3 material-select withBordr">
            <span *ngIf="!readOnlyAccess">
              <ng-select name="ddlAssociateLocation"
                         [items]="associateLocationData"
                         class="custom-select-grower grower-add-drop pb-0 associate-crop-select"
                         [(ngModel)]="associateOrder.AssociateLocation"
                         [virtualScroll]="true"
                         [loading]="shipToDataLoading"
                         bindLabel="description"
                         placeholder="Associate Location:"
                         bindValue="locationId"
                         [disabled]="(readOnlyAccess)"
                         [closeOnSelect]="true"
                         (change)=getCropYearType($event)>
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-4">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.description}}
                        </h4>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </span>
            <span *ngIf="readOnlyAccess && locationDetail">
              <p  class="mb-0 contact-info">Associate Location:</p>
              <p class="mb-0 contact-info">{{locationDetail?.description}}</p>
            </span>
            <p *ngIf="locationDetail" class="mb-0 contact-info">Contact: {{locationDetail?.contact}}</p>
            <p *ngIf="locationDetail" class="mb-0 contact-info">Email: {{locationDetail?.email}}</p>
            <p *ngIf="locationDetail" class="mb-0 contact-info">Phone Number: {{locationDetail?.associatePhoneNumber}}</p>
          </div>
          <div class=" col-md-4 material-select withBordr">
            <ng-select name="ddlShipTo"
                       [items]="shipToData"
                       class="custom-select-grower grower-add-drop pb-0 associate-crop-select"
                       [virtualScroll]="true"
                       [(ngModel)]="associateOrder.ShipToAccount"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       placeholder="Ship To:"
                       [closeOnSelect]="true"
                       [loading]="locationDataLoading"
                       [searchFn]="accountSearchFn"
                       (change)="getShipTo($event)"
                       (clear)="getShipTo($event)"
                       [disabled]="(readOnlyAccess)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" *ngIf="!item.address2" [ngOptionHighlight]="search">
                        {{item.address1}}, {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="address" *ngIf="item.address2" [ngOptionHighlight]="search">
                        {{item.address1}}, {{item.address2}}, {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
            <div class="shipTo">
              <div *ngIf="selectedDealer">
                <p>
                  Account#: {{selectedDealer.accountNumber}}
                </p>
                <p *ngIf="!selectedDealer.address2">
                  Address: {{selectedDealer.address1}}, {{selectedDealer.city}}, {{selectedDealer.state}} - {{selectedDealer.zipCode}}
                </p>
                <p *ngIf="selectedDealer.address2">
                  Address: {{selectedDealer.address1}}, {{selectedDealer.address2}},  {{selectedDealer.city}}, {{selectedDealer.state}} - {{selectedDealer.zipCode}}
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4 material-select nonRequired withBordr">
            <ng-select name="ddlDeliverTo"
                       [items]="deliverToData"
                       class="custom-select-grower grower-add-drop pb-0 associate-crop-select"
                       [virtualScroll]="true"
                       [(ngModel)]="associateOrder.DeliverTo"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       placeholder="Deliver To:"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn"
                       [disabled]="readOnlyAccess || !associateOrder.DeliverToAnotherLocation"
                       (change)="getDeliverToAccount($event)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
            <div class="shipTo">
              <div *ngIf="deliverTo">
                <p>
                  Account#: {{deliverTo.accountNumber}}
                </p>
                <p>
                  Address: {{deliverTo.address1}},  {{deliverTo.city}}, {{deliverTo.state}} - {{deliverTo.zipCode}}
                </p>
              </div>
            </div>
            <div class="checkbox-color checkbox-alignment">
              <mat-checkbox class="custom-checkbox p-0"
                            [disabled]="readOnlyAccess"
                            [style.display]=""
                            [indeterminate]=""
                            (change)="removeDeliverTo()"
                            [(ngModel)]="associateOrder.DeliverToAnotherLocation"
                            data-testid="ddl-deliver-to-checkbox">I want this delivered to another location.</mat-checkbox>
            </div>
          </div>
        </div>
        <div class="row">
         
        </div>
        <div class="row">
          <div class="col-md-4 customerPO">
            <div class="row">
              <div class="col-md-6 material-select withBordr mt-3">
                <ng-select name="ddlCropType"
                           [items]="cropTypeData"
                           class="custom-select-grower grower-add-drop"
                           [virtualScroll]="true"
                           bindLabel="cropDesc"
                           placeholder="Crop Type"
                           bindValue="cropTypeCode"
                           (change)="setLocation($event)"
                           (clear)="clearDetailGrid()"
                           [(ngModel)]="associateOrder.CropType"
                           [closeOnSelect]="true"
                           [disabled]="(readOnlyAccess)">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-4">
                          <h4 class="name greenColor" [ngOptionHighlight]="search">
                            {{item.cropDesc}}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            
            </div>
          </div>
          <div class="col-md-3"></div>
          <div class="col-md-4 checkbox-color">
            Customer Pickup:  <mat-checkbox #CustomerPickupCheck class="custom-checkbox margin-l10"
                                            [style.display]=""
                                            [indeterminate]=""
                                            [(ngModel)]="associateOrder.IsCustomerPickup"
                                            [disabled]="(readOnlyAccess)"
                                            matTooltip="Select For Customer Pickup" [matTooltipPosition]="'above'"
                                            data-testid="ddl-customer-pickup"></mat-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 deliveryNotes material-select">
            <div class="row">
              <mat-form-field class="wide100 col-md-11">
                <mat-label>Delivery Instructions:</mat-label>
                <input matInput type="text" name="deliveryInstructionsCodes" class="pb-1" data-testid="btn-delivery-instructions-codes"
                       [(ngModel)]="associateOrder.DeliveryInstructionsCodes"
                       [readonly]="readOnlyAccess"
                       [disabled]="(readOnlyAccess)"
                       [maxLength]="50">
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-2 customerPO">
            <mat-form-field class="wide100">
              <mat-label>Customer PO:</mat-label>
              <input matInput type="text" name="customerPO" class="pb-1"
                     [(ngModel)]="associateOrder.CustomerPO"
                     [readonly]="readOnlyAccess"
                     [disabled]="(readOnlyAccess)"
                     [maxLength]="25">
            </mat-form-field>
          </div>

          <div class="col-md-3">
            <mat-form-field>
              <mat-label>Requested By Date</mat-label>
              <input matInput [readonly]="true" [matDatepicker]="picker" (dateChange)="validateDate($event)" [(ngModel)]="associateOrder.RequestedDate" placeholder="Requested Date" (focus)="picker.open();" [min]="minDate" [max]="maxDate" [matDatepickerFilter]="dateFilter">
              <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="readOnlyAccess"></mat-datepicker-toggle>
              <mat-datepicker #picker [disabled]="readOnlyAccess"></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-md-3 mt-4" *ngIf="!readOnlyAccess">
            <button mat-raised-button class="btns" [disabled]="!associateOrder.AssociateLocation || !associateOrder.CropType || !associateOrder.ShipToAccount" (click)="getProductsList()" data-testid="btn-compute-inventory2">Display</button>
          </div>
        </div>
      </div>

      <div class="OrderReleaseDetail">
        <!--Product Detail section-->
        <div class="form-sec"  *ngIf ="!readOnlyAccess">

          <div class="row margin-r0 margin-b20">
            <div class="col-md-11 product-filter-outer">
              <div class="product-filter-outer">
                <div class="product-filter col-md-12">
                  <div class="search-category">
                    <div class="brand-dropdown default-select agent-crop-select">
                      <ng-select [items]="searchTypeList"
                                 name="ddlProductSearch"
                                 [(ngModel)]="productSearchFilter"
                                 [virtualScroll]="true"
                                 [closeOnSelect]="true"
                                 [selectOnTab]="true"
                                 [clearable]="false"
                                 bindLabel="name"
                                 bindValue="value"
                                 [searchable]="false"
                                 (change)="keepFilter()"
                                 placeholder="Select Category">
                      </ng-select>
                    </div>
                  </div>
                  <div class="search-box">
                    <div class="row margin-0">
                      <div class="default-select select-container">
                        <div *ngIf="productSearchFilter === 'Variety'">
                          <div class="searchInputBox">
                            <span class="search-icon">
                              <i class="fas fa-search"></i>
                            </span>
                            <div class="select-container">
                              <input class="custom-select-grower"  [(ngModel)]="productFilters.Variety" placeholder="Search...">
                            </div>
                          </div>
                        </div>
                        <div class="agent-crop-select">
                          <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'marketingBrand'"
                          [items]="marketingMasterList"
                          placeholder="Search..."
                          class="custom-select-grower"
                          [multiple]="true"
                          [hideSelected]="true"
                          [(ngModel)]="productFilters.MarketingBrandList"
                          [virtualScroll]="true"
                          bindLabel="value"
                          bindValue="id"
                          [closeOnSelect]="true"
                          [searchFn]="filterSearchFn"
                          (change)="keepFilter()">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <p class="name">
                                    {{item.value}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                        </ng-select>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row chips-sec" *ngIf="filterValueList != '' ">
                  <div class="col-sm-9 col-md-10 selected-chip">
                    <mat-chip-set>
                      <mat-chip selected *ngFor="let filterValue of filterValueList">
                        {{filterValue}}
                        <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                          <i class="fas fa-times text-right"></i>
                        </a>
                      </mat-chip>
                    </mat-chip-set>
                  </div>
                  <div class="col-sm-3 col-md-2 text-right">
                    <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-1">
              <button mat-raised-button (click)="getFilterData()" class="btns">Search</button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 productTableOuter">
            <div class="tableContainer">
              <table mat-table [dataSource]="associateOrderSource" multiTemplateDataRows class="matTables productTable">
                <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                  <div *ngIf="column=='marketingBrand'"><th mat-header-cell *matHeaderCellDef class="text-center">Marketing Brand</th>
            </div>
            <div *ngIf="column=='variety'"><th mat-header-cell *matHeaderCellDef class="text-center">Variety</th></div>
            <div *ngIf="column=='availableQty'"><th mat-header-cell *matHeaderCellDef class="convFactor text-center">Available Qty</th></div>
            <div *ngIf="column=='orderQty'"><th mat-header-cell *matHeaderCellDef class="text-center releaseQuantity">Order Qty</th></div>
            <div *ngIf="column=='uom'"><th mat-header-cell *matHeaderCellDef class="text-center">UOM</th> </div>
            <div *ngIf="column=='preferredPackagingSize'"><th mat-header-cell *matHeaderCellDef class="total-units text-center">Preferred Pkg Size</th></div>

            <td mat-cell *matCellDef="let element">

              <div *ngIf="column=='marketingBrand'" class="text-center">
                <div>
                  <p>{{element.marketingBrand}}</p>
                </div>
              </div>
              <div *ngIf="column=='variety'" class="text-center">
                <div>
                  <p>{{element.variety}}</p>
                </div>
              </div>

              <div *ngIf="column=='availableQty'" class="available-block text-center">
                <div>
                  <span> {{element.availableQty | number}}</span>
                </div>
              </div>

              <div *ngIf="column=='orderQty' && !readOnlyAccess" class="text-center">
                <div>
                  <button (click)="AssociateOrderUnitChange('decrease',element)" class="plus-minus-btn minusBtn"> - </button>
                  <input type="text" class="geu-txt padding-t2" [(ngModel)]="element.orderQty" (focusout)="enableDisablePlaceOrder()" (keyup)="quantityTextChange(element)" maxlength="15" appNumbersOnly />
                  <button (click)="AssociateOrderUnitChange('increase',element)" class="plus-minus-btn plusBtn"> + </button>
                </div>
              </div>
              <div *ngIf="column=='orderQty' && readOnlyAccess" class="text-center">
                <div>
                  <span> {{element.orderQty}}</span>
                </div>
              </div>
              <div *ngIf="column=='uom'" class="text-center">
                <div>
                  <span> {{element.uom}}</span>
                </div>
              </div>
              <div *ngIf="column=='preferredPackagingSize' && !readOnlyAccess" class="text-center">
                <div>
                  <input type="text" class="geu-txt padding-t2 input-width" [(ngModel)]="element.preferredPackagingSize" maxlength="50" />
                </div>
              </div>

              <div *ngIf="column=='preferredPackagingSize' && readOnlyAccess" class="text-center">
                <div>
                  <span class="geu-txt padding-t2"> {{element.preferredPackagingSize}}</span>
                </div>
              </div>
            </td>
            </ng-container>
            <ng-container matColumnDef="expandedDetail">
              <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                <div class="inline-error" *ngIf="element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.rowId}}">
                  <div class="row">
                    <div class="col-md-9">
                      <ol class="error-list">
                        <li *ngFor="let err of element.lineErrors.errors">
                          {{err.error}}
                      </ol>
                    </div>
                    <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                      <span>
                        Revert to Previous.
                        <i class="icon-ico-Reply"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
            <div *ngIf="associateOrderSource == undefined || (associateOrderSource && associateOrderSource.data.length == 0)" class="noDataMsg">
              <p class="padding-b47">No Record Found.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="common-error-block" *ngIf="showErrorBlock && errorMsgs.length>0 && errorMsgs[index].errors.length > 0">
    <div class="row">
      <div class="col-md-2 padding-r0 errCountOuter">
        <!--<span class="close-icon">
          <i class="icon-ico-Error"></i>
        </span>-->
        <span class="errorCounting">
          {{currentErrorRow}} of {{errorMsgs.length}}
        </span>
      </div>
      <div class="col-md-6 padding-l0 ">
        <ul class="errorMsg">
          <li *ngFor="let err of errorMsgs[index].errors">
            <p> {{err.error}}</p>
          </li>
        </ul>
      </div>
      <div class="col-md-4 button-sec text-right">
        <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()" data-testid="btn-revert-errors">Revert All Errors</button>
        <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>0" (click)="nextError()" data-testid="btn-next-error">Next Error</button>
      </div>
    </div>
  </div>
  <div class="SeedFulfillBtnSec">
    <div class="row">
      <div class="col-md-12">
        <button  *ngIf ="!readOnlyAccess" mat-raised-button class="btns" [disabled]="isPlaceOrderDisable || !associateOrder.AssociateLocation || !associateOrder.CropType" (click)="placeAssociateOrder()" data-testid="btn-place-order">Place Order</button>
        <!--<button mat-raised-button class="btns" color="primary" (click)="navigateToAssociateLanding()" data-testid="btn-back-to-landing">Back to View Orders</button>-->
        <button  *ngIf ="!readOnlyAccess" mat-raised-button class="btns" color="primary" (click)="navigateToAssociateLanding()" data-testid="btn-seed-crop-associates-cancel">Cancel</button>
        <button  *ngIf ="readOnlyAccess" mat-raised-button class="btns" color="primary" (click)="navigateToAssociateLanding()" data-testid="btn-seed-crop-associates-back">Back to View Orders</button>
      </div>
    </div>
  </div>
</div>

